import { makeAutoObservable, runInAction } from 'mobx';
import { services } from '../services';

export class UserStore {
    /**
     * Признак авторизации пользователя.
     */
    private _isAuthorized: boolean = !!localStorage.getItem('access_token');
     
    /**
     * Признак наличия согласия на обработку ПНД.
     */
    private _hasConsent: boolean = this.tokenHasConsentClaim;

    /**
    * Признак наличия ПА
    */
    private _isSuspiciousActivity: boolean = this.tokenHasSuspicioutActivityClaim;

    /**
     * Признак, что пользователь админ
     */
    private _isAdmin: boolean = this.tokenHasAdminClaim;

    /**
     * Признак, что пользователь админ
     */
    private _isOperator: boolean = this.tokenHasOperatorClaim;

    /**
     * Признак, что время пользователя рассинхронизировано с сервером.
     */
    private _isTimeDesynchronization: boolean = false

    /**
     * Конструктор.
     */
    constructor() {
        makeAutoObservable(this);
    }

    /**
     * Идентификатор текущего пользователя
     */
    public get currentUserId() {
        return services.tokenService.decodeAccessToken(services.tokenService.accessToken).sub;
    }

    /**
     * Признак авторизации пользователя.
     */
    public get isAuthorized() {
        return this._isAuthorized;
    }

    /**
     * Признак, что время пользователя рассинхронизировано с сервером.
     */
    public get isTimeDesynchronization() {
        return this._isTimeDesynchronization;
    }

    /**
     * Метод авторизации пользователя
     */
    public Authorize(accessToken: string, refreshToken: string) 
    {
        services.tokenService.setTokens(accessToken, refreshToken);
        this._isAuthorized = true;
        this._isSuspiciousActivity = this.tokenHasSuspicioutActivityClaim;
        this._hasConsent = this.tokenHasConsentClaim;
        this.chooseRole();
    }

    /**
     * Метод выхода из системы.
     */
    public Logout() {
        services.tokenService.removeTokens();
        this._isAuthorized = false;
        this._isAdmin = false;
        this._isOperator = false;
        this._isSuspiciousActivity = false;
    }

    /**
     * Метод установки значения есть ли рассинхронизация с временем.
     */
    public set isTimeDesynchronization(isDesynchronization: boolean) {
        this._isTimeDesynchronization = isDesynchronization
    }

    /**
     * Признак, является ли пользователь админом.
     */
    public get isAdmin() {
        return this._isAdmin;
    }

    /**
     * Признак, является ли пользователь админом.
     */
    public get isOperator() {
        return this._isOperator;
    }

    /**
     * Проверка наличия согласия на обработку ПНД.
     */
     public get hasConsent() {
        return this._hasConsent;
    }

    public set hasConsent(value: boolean) {
        this._hasConsent = value;
    }

    /**
     * Признак, является ли сессия подозрительной с ограниченным токеном.
     */
    public get isSuspiciousActivity() {
        return this._isSuspiciousActivity;
    }

    public set isSuspiciousActivity(value: boolean) {
        this._isSuspiciousActivity = value;
    }

    /**
     * Возвращает признак, что токен содержит данные ПА
     */
    private get tokenHasSuspicioutActivityClaim() {
        const access_token = localStorage.getItem('access_token');

        const scope : string[] = access_token ? this.decodeAccessToken(access_token)?.scope : [];
        return scope ? scope.some(el => el === 'ssoapi.user_confirmation') : false
    }

    /**
     * Возвращает признак что токен содержит согласие
     */
    private get tokenHasConsentClaim() {
        const access_token = localStorage.getItem('access_token');

        const scope : string[] = access_token ? this.decodeAccessToken(access_token)?.scope : [];
        return scope ? scope.some(el => el === 'ssoapi.hasconsent') : false
    }

    /**
     * Возвращает признак, что токен содержит роль Админа
     */
    private get tokenHasAdminClaim() {
        const access_token = localStorage.getItem('access_token');

        const roleOrRoles: string[] | string = access_token ? this.decodeAccessToken(access_token)?.role : [];
        const roles = [roleOrRoles].flat();
        return roles ? roles.some(el => el === 'Administrator') : false;
    }

    /**
     * Возвращает признак, что токен содержит роль Оператор
     */
    private get tokenHasOperatorClaim() {
        const access_token = localStorage.getItem('access_token');

        const roleOrRoles: string[] | string = access_token ? this.decodeAccessToken(access_token)?.role : [];
        const roles = [roleOrRoles].flat();
        return roles ? roles.some(el => el === 'Operator') : false;
    }

    /**
     * Метод установки актуальной роли пользователя
     */
    private chooseRole()
    {
        runInAction(() => {
            if(this.tokenHasAdminClaim) {
                this._isAdmin = true;
                return;
            }

            this._isOperator = this.tokenHasOperatorClaim;
        })
    }


    /**
     * Расшифровать токен доступа.
     */
    private decodeAccessToken(accessToken: string) {

        if(!accessToken)
            return "";

        const base64Url = accessToken.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
            window
                .atob(base64)
                .split('')
                .map(function (c) {
                    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                })
                .join(''),
        );

        return JSON.parse(jsonPayload);
    }
}
